import React, { Component } from 'react';
import Tooltip from '@material-ui/core/Tooltip';

import './DoughnutStyle.css';

class   DoughnutLegend extends Component {
    createMarkup= (string, color) => {
        let cadena = string.toString().replace(/green/g, color);
        console.log(cadena);
        return { __html: cadena };
    };

    render() {
        return (
            <Tooltip title={this.props.name}>
                {/* <SvgIcon style={{ marginTop: '5px', marginRight: '0' }}>
                    <svg dangerouslySetInnerHTML={this.createMarkup(this.props.markup, this.props.color)} />
                </SvgIcon> */}
                <label style={{ color: this.props.color}}>{'Casos:' + this.props.label}</label>
            </Tooltip>
        )
    }
}

export default DoughnutLegend; 